/* eslint-disable no-invalid-this */
/* eslint-disable max-lines-per-function */
/* eslint-disable no-underscore-dangle */
import React from "react";
import ReactQuill, { Value } from "react-quill";
import "react-quill/dist/quill.snow.css";
import QuillDelta from "quill-delta";
import { Feature } from "types/gql-types";
import { FeatureFlag } from "../feature";
import CustomToolbar from "./custom-toolbar";
import "./editor.css";
import "./variable-tag-blot";

type NonUndefined<T> = T extends undefined ? never : T;
type NonString<T> = T extends string ? never : T;

type Props = {
  onChange: any,
  value?: any,
  readOnly?: boolean,
  toolbarId?: string
  characterLimit?: number,
  placeholder?: string,
}
export const emptyDelta = new QuillDelta();

const formats = [
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "color",
  "align",
  "code",
  "VariableTag",
];

const getVariableByName = (name: string) => {
  switch (name) {
    case "fullName":
      return "{{applicant_first_name}} {{applicant_last_name}}";
    case "firstName":
      return "{{applicant_first_name}}";
    case "lastName":
      return "{{applicant_last_name}}";
    case "linkCode":
      return "{{link_code}}";
    case "lotteryNumber":
      return "{{lottery_number}}";
    case "positionNumber":
      return "{{position_number}}";
    case "todaysDate":
      return "{{todays_date_est}}";
    case "loginInstructions":
      return "{{login_instructions}}";
    case "forgotPasswordInstructions":
      return "{{forgot_password_instructions}}";
    case "noHcAccountInstructions":
      return "{{no_hc_account_instructions}}";
    case "propertyName":
      return "{{property_name}}";
    case "propertyAddress":
      return "{{property_address}}";
    case "propertyEmail":
      return "{{property_email}}";
    case "propertyPhone":
      return "{{property_phone}}";
    case "organizationName":
      return "{{organization_name}}";
    case "preApplicationURL":
      return "{{pre_application_url}}";
    case "fullApplicationURL":
      return "{{full_application_url}}";
    case "documentUploadInstructions":
      return "{{document_upload_instructions}}";
    case "applicationId":
      return "{{application_id}}";
    default:
      throw new Error(`Invalid match: ${name}`);
  }
};
class Editor extends React.Component<Props, {isPickerOpen: boolean}> {
  constructor (props: Props) {
    super(props);
    this.state = { isPickerOpen: false };
    this.handleChange = this.handleChange.bind(this);
  }

  quill = null as (NonUndefined<ReactQuill["editor"]> | null);

  reactQuillRef = null as (ReactQuill | null);

  toggleVariablePicker = () => this.setState({ isPickerOpen: !this.state.isPickerOpen });

  handleChange = () => {
    if (!this.quill) return;
    let delta = this.quill.getContents();
    if (this.quill.getLength() === 1) {
      delta = emptyDelta as unknown as NonString<NonUndefined<Value>>;
    }
    this.props.onChange(delta);
  };
  // handleChange (
  //   _value: string,
  //   _delta: any,
  //   _source: any,
  //   editor: ReactQuill.UnprivilegedEditor,
  // ) {
  //   let delta = editor.getContents() as unknown as Delta;
  //   if (editor.getLength() === 1) delta = new QuillDelta();
  //   console.log("delta", delta);
  //   // props.onChange(delta);
  // }


  // save reference to the quill library so other funcs can refer to it
  attachQuillRefs () {
    if (!this.reactQuillRef) return;
    this.quill = this.reactQuillRef.getEditor();
    // @ts-ignore
    window._quillRef = this.quill;

  }

  componentDidMount () {
    this.attachQuillRefs();
  }

  componentDidUpdate () {
    this.attachQuillRefs();
  }


  handleClickVariable = (e: any) => {
    if (!this.quill) return;
    const varName = e.target.dataset.var;
    const labelName = e.target.innerText;
    const tmplVar = getVariableByName(varName);
    const range = this.quill.getSelection(true);
    const opts = { marker: tmplVar, title: labelName };

    this.quill.insertEmbed(range.index, "VariableTag", opts);

    // Add zero-width non-breaking space after the VariableTag to be able to
    // put the cursor after the VariableTag without a real space character.
    // This creates another problem... having to press the Backspace key twice
    // to remove the VariableTag, since it also has to remove this added
    // character as well.
    this.quill.insertText(range.index + 1, "\uFEFF", "user");

    // move cursor to the end of the variable
    this.quill.setSelection(range.index + 2, range.length, "silent");
    const delta = this.quill.getContents();
    this.props.onChange(delta);
    this.setState({ isPickerOpen: false });
  };


  render () {
    const modules = {
      toolbar: {
        container: `#${this.props.toolbarId}`,
        handlers: {
          code: this.toggleVariablePicker,
        },
      },
    };
    const { characterLimit = 10000, value, readOnly, toolbarId } = this.props;
    const checkCharacterCount = (event: any) => {
      if (!this.quill) return;
      if (this.quill.getLength() > characterLimit && event.key !== "Backspace") {
        event.preventDefault();
      }
    };

    const characterCount = this.quill ? this.quill.getLength() - 1 : 0;
    const showWarning = characterCount >= characterLimit;
    return (
      <div className="text-editor">
        <CustomToolbar id={toolbarId} />
        {this.state.isPickerOpen && (
          <FeatureFlag>
            {(isEnabled) => (
              <div className="tmpl-var-dropdown card">
                <ul onClick={this.handleClickVariable}>
                  <li data-var="fullName">Applicant First &amp; Last Name</li>
                  <li data-var="firstName">Applicant First Name</li>
                  <li data-var="lastName">Applicant Last Name</li>
                  <li data-var="applicationId">Application ID</li>
                  <li data-var="linkCode">Application Link Code</li>
                  <li data-var="lotteryNumber">Application Lottery Number</li>
                  <li data-var="positionNumber">Application Position Number</li>
                  <li data-var="forgotPasswordInstructions">Forgot Password Instructions</li>
                  <li data-var="preApplicationURL">Pre-application Link</li>
                  {isEnabled(Feature.ELIGIBILITY_FORM) && (
                    <li data-var="fullApplicationURL">Full Application Link</li>
                  )}
                  <li data-var="loginInstructions">Login Instructions</li>
                  <li data-var="noHcAccountInstructions">No HC Account Instructions</li>
                  <li data-var="organizationName">Organization Name</li>
                  <li data-var="propertyName">Property Name</li>
                  <li data-var="propertyAddress">Property Address</li>
                  <li data-var="propertyEmail">Property Email</li>
                  <li data-var="propertyPhone">Property Phone</li>
                  <li data-var="todaysDate">Today&apos;s Date</li>
                  {isEnabled(Feature.APPLICANT_DOCUMENT_UPLOAD) && (
                    <li data-var="documentUploadInstructions">Upload Document Instructions</li>
                  )}
                </ul>
              </div>
            )}
          </FeatureFlag>
        )}
        <ReactQuill
          ref={el => {
            this.reactQuillRef = el;
          }}
          onKeyDown={checkCharacterCount}
          onChange={this.handleChange}
          // selection={{ start: 0, end: 0 }}
          style={{ color: "#000" }}
          modules={modules}
          formats={formats}
          value={value}
          readOnly={readOnly}
          placeholder={this.props.placeholder}
        />
        {characterLimit !== 10000 && (
          <div className="character_counter" style={showWarning ? { color: "red" } : {}}>
            {showWarning ? "Maximum Characters Reached " : ""}
            {characterCount} / {characterLimit} characters
          </div>)}
      </div>);
  }
}

export default Editor;
